import script from "./WxBindComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./WxBindComp.vue?vue&type=script&setup=true&lang=ts"

import "./WxBindComp.vue?vue&type=style&index=0&id=7bc100c5&scoped=true&lang=css"

import exportComponent from "D:\\laoyou\\rez-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc100c5"]])

export default __exports__